import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'brand_leads-case_study_section_linked_pdf-click';
/**
 * Click event to track pdf view in case study section on brand landing page
 */
export function trackBrandLeadsCaseStudySectionLinkedPdfClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
